import { observable, makeObservable, override } from "mobx";
import { MrbFilterParameters } from "mrb/core/filter";
import moment from "moment";
import { applicationDefaults } from "common/constants";

class ProducerPaymentReportFilter extends MrbFilterParameters {
    @observable from;
    @observable to;
    @observable timeZone;

    constructor() {
        super();
        makeObservable(this);
        this.reset();
    }

    @override
    reset() {
        super.reset();
        this.from = moment().subtract(1, "month").startOf("month").format(applicationDefaults.formats.isoDate);
        this.to = moment().subtract(1, "month").endOf("month").format(applicationDefaults.formats.isoDate);
        this.timeZone = moment.tz.guess();
    }
}

export default ProducerPaymentReportFilter;
